export default "__VITE_ASSET__Cntokxor__"